import React from 'react';
import Head from 'next/head';

import { useViewerQuery } from '@edx/graphql/generated';
import { ResponsiveImage } from '@edx/types/responsive-image';
import { ContactForm } from '@edx/components/contact-form';

type Props = {
  bgImage: ResponsiveImage;
};

export const ContactPage: React.FC<Props> = ({ bgImage }) => {
  const { data } = useViewerQuery({ ssr: false });

  const email = data?.viewer.email || '';
  const fullName =
    data?.viewer.firstName && data.viewer.lastName ? `${data?.viewer.firstName} ${data.viewer.lastName}` : '';

  return (
    <>
      <Head>
        <title key="title">Contacto</title>
      </Head>

      <ContactForm bgImage={bgImage} userFullName={fullName} userEmail={email} />
    </>
  );
};
